module.exports = __webpack_public_path__ + "static/media/webdesign-services-img73.2ed6f87c.jpg";